import sliders from '../../../src/js/shared/sliders';

'use strict';
const $ = jQuery.noConflict();
$(function() {

	const testimonialBlock = {

		init: function() {
			this.cacheDOM();
			this.sliderInit();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$slider = $('.js-testimonial-block');
			this.$prev = $('.js-testimonial-block-prev');
			this.$next = $('.js-testimonial-block-next');
		},

		sliderInit: function() {
			const sliderConfig = {
				slidesToShow: 3,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '40px',
				arrows: false,
				// autoplay: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							centerPadding: '30px'
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							centerPadding: '60px'
						}
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 1,
							centerPadding: '24px'
						}
					}
				]
			};

			sliders.initializeSlider('.js-testimonial-block', sliderConfig);
		},

		bindEvents: function() {
			this.$prev.on('click', () => this.$slider.slick('slickPrev'));
			this.$next.on('click', () => this.$slider.slick('slickNext'));
		},

	};

	testimonialBlock.init();

});
